import React from 'react';

export interface IconText {
  icon: React.ReactNode;
  text: string;
  units: string;
  /** Name of the metric, e.g. "GHG". Used by the sustainability tooltip. */
  label?: string;
  /** Variant attribute the value was read from, e.g. "impacts-ghg". */
  attributeKey?: string;
}

enum Size {
  sm = 12,
  base = 24,
  lg = 36,
  xl = 48,
}

interface IconTextRowProps {
  iconsWithText: IconText[];
  size?: Size;
  direction?: string;
  environmentalTextColor?: string;
}

const GreenLandScore: React.FC<IconTextRowProps> = ({ iconsWithText, size, direction, environmentalTextColor }) => {
  return (
    <div className={`${direction || 'flex items-center'}`} data-testid="greenland-score">
      {iconsWithText.map((iconText, index) => {
        const value = parseFloat(iconText.text);
        if (isNaN(value)) {
          return <></>;
        }

        return (
          <div key={index} className={`mb-4 mr-14 flex items-center`} data-testid={`greenland-score-item-${index}`}>
            {!!direction && (
              <>
                <div className="flex h-31 w-26 items-center justify-center 2xl:h-62 2xl:w-52">{iconText.icon}</div>
                <p
                  className={`flex font-primaryThin text-14 font-normal leading-3 md:text-18`}
                  style={{ color: environmentalTextColor }}
                >
                  {`${parseFloat(iconText.text).toFixed(1)}  ${iconText.units}`}
                </p>
              </>
            )}
            {!direction && (
              <>
                <div className="flex size-14 items-center justify-center overflow-hidden">
                  <div className="flex size-full items-center justify-center">{iconText.icon}</div>
                </div>
                <p
                  className="hidden font-primaryThin text-11 font-normal leading-3 lg:flex"
                  style={{ color: environmentalTextColor }}
                >
                  {`${parseFloat(iconText.text).toFixed(1)}  ${iconText.units}`}
                </p>
                <p
                  className="font-primaryThin text-11 font-normal leading-3 lg:hidden"
                  style={{ color: environmentalTextColor }}
                >
                  {parseFloat(iconText.text).toFixed(1)}
                </p>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default GreenLandScore;
